import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const NavMenu = ({ isOpen, onClose }) => {
  return (
    <>
  
      {isOpen && (
        <div className="menu-overlay" onClick={onClose}></div>
      )}
      
    
      <nav className={`nav-menu ${isOpen ? 'open' : ''}`}>
        <ul>
          <li>
            <Link to="/" onClick={onClose}>Home</Link>
          </li>            
          <li>
            <Link to="/sobre" onClick={onClose}>Sobre</Link>
          </li>
          <li>
            <Link to="/contato" onClick={onClose}>Contacto</Link>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default NavMenu;